import { AppThunk } from '../../../store/rootReducer';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { isUpdatingRuler2dSelector } from '../selectors/ruler2d.selectors';
import { Tool } from '../../tool/utils/tool.utils';
import * as ruler2dActions from '../actions/ruler2d.actions';

export const setRuler2dTimestamp =
  (timestamp: number): AppThunk =>
  async (dispatch, getState) => {
    const isUpdatingRuler2d = isUpdatingRuler2dSelector(getState());
    const isRuler2dActive = isToolActiveSelector(Tool.ruler2d)(getState());

    if (isUpdatingRuler2d && isRuler2dActive) {
      dispatch(
        ruler2dActions.setTimestamp({
          timestamp,
          meta: { history: false },
        }),
      );
    }
  };
